import { render, staticRenderFns } from "./CellSidebar.vue?vue&type=template&id=4ae0cb28"
import script from "./CellSidebar.vue?vue&type=script&lang=js"
export * from "./CellSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports